import { ListItemButton, Stack, Typography, useTheme } from '@mui/material'
import type { DefaultConfig } from './types'

export type DefaultConfigRowProps = {
  channel: DefaultConfig['channel']
  currencySupport: DefaultConfig['currencySupport']
  onClick: () => void
}

const formatCurrencySupport = (currencySupport: DefaultConfig['currencySupport']): string => {
  if (currencySupport.type === 'SPECIFIC' && currencySupport.currencies?.length) {
    return `Currencies: ${currencySupport.currencies.join(', ')}`
  }
  return `Currencies: ${currencySupport.type}`
}

export const DefaultConfigRow = ({ channel, currencySupport, onClick }: DefaultConfigRowProps) => {
  const { palette } = useTheme()

  return (
    <ListItemButton onClick={onClick}>
      <Stack
        direction="row"
        sx={{
          padding: 2,
          flex: 1,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Stack
          sx={{
            gap: 1,
          }}
        >
          <Typography variant="p1Medium">
            {channel.type} — {channel.channelId}
          </Typography>
          <Typography variant="subtitle1" sx={{ color: palette.text.secondary }}>
            {formatCurrencySupport(currencySupport)}
          </Typography>
        </Stack>
      </Stack>
    </ListItemButton>
  )
}
